<template>
  <div class="member-details-section">
    <page-title/>
    <div v-if="$isInternalUser" container>
      <div grid>
        <div column="6">
          <app-input
            label="Filebound ID"
            inputId="filebound-id"
            v-model='$v.fileBoundId.$model'
            :errorMessage="fileBoundIdError"
            :invalid="$v.fileBoundId.$invalid"
            class="_inline-block"
          />
          <async-button class="_mls btn --sm" @clicked="submit" :executing="isSubmitting">Save</async-button>
        </div>
      </div>
    </div>

    <cloud-cannon-content
      class="_p0 _ptxs bg-light-gray"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.header"
    />

    <accordion>
      <personal-information/>
      <member-coverage
        :member="memberDetails.member"
        >

        <template #collapser><accordion-collapser /></template>
      </member-coverage>
      <contact-information-read-only
        :loading="memberDetailsLoading"
        :address="memberDetails.member.homeAddress"
      />
      <related-information :can-add-dependent="false"/>
      <privacy-address
        :memberDetailsLoading="memberDetailsLoading"
        :value="computedPrivacyAddress"
        :readOnly="true"
      />
      <language-assistance
        :loading="memberDetailsLoading"
        :language="memberDetails.member.additionalMemberInfo"
      />
      <member-eligibility />
      <!--benefit-summary v-if="memberDetails.benefits"/-->
      <MemberBenefitTiersContainer :memberCK = "memberCk" :dos="memberDetails.member.benefitServiceDate" :authToken="memberDetails.member.token"/>
    </accordion>

    <cloud-cannon-content
      class="_pts _pbxs bg-light-gray"
      :content-loading="cloudCannonContentLoading"
      :content="cloudCannonContent.footer"
    />
  </div>
</template>

<script>
  /** Mixins */
  import queryParamable from '@mixins/queryParamable'
  import fetchable from '@mixins/fetchable'
  import memberManagement from '@mixins/memberManagement'
  import formattable from '@mixins/formattable'
  import validationMessages from '@mixins/validationMessages'
  import memberEdit from '@mixins/memberEdit'

  /** Components */
  import Accordion from '@sections/Accordion'
  import AccordionCollapser from '@molecules/AccordionCollapser'
  import AsyncButton from '@molecules/AsyncButton'

  /** Sections */
  import PageTitle from './MemberDetails/PageTitle'
  import MemberCoverage from '@views/MemberManagement/MemberPartials/MemberCoverage'
  import PersonalInformation from './MemberDetails/PersonalInformation'
  import ContactInformationReadOnly from './MemberPartials/ContactInformationReadOnly'
  import RelatedInformation from './MemberPartials/RelatedInformation'
  import MemberEligibility from './MemberDetails/MemberEligibility'
  import PrivacyAddress from './MemberEdit/PrivacyAddress'
  // import BenefitSummary from '@organisms/BenefitSummary';
  import MemberBenefitTiersContainer from './MemberBenefitTiersContainer'
  import LanguageAssistance from './MemberDetails/LanguageAssistance'
  import CloudCannonable from '@mixins/CloudCannonable'
  import AppInput from '@atoms/Input'

  import { maxLength } from 'vuelidate/lib/validators'
  import { fileBoundIdValidation } from '@/utils'

  export default {
    mixins: [queryParamable, fetchable, memberManagement, formattable, CloudCannonable, validationMessages, memberEdit],
    components: {
      MemberBenefitTiersContainer,
      LanguageAssistance,
      Accordion,
      AccordionCollapser,
      PageTitle,
      MemberCoverage,
      PersonalInformation,
      ContactInformationReadOnly,
      RelatedInformation,
      MemberEligibility,
      // BenefitSummary,
      PrivacyAddress,
      AppInput,
      AsyncButton
    },
    computed: {
      memberCk() {
        return this.$store.getters['hiddenRouteData/getHiddenRouteData'].memberCk
      },
      fetchers () {
        return [
          {
            action: 'GET_MEMBER_DETAILS',
            options: {
              memberCk: this.memberCk,
              params: {
                isEligibility: true,
                isBenefit: true,
                dateOfService: this.now()
              }
            }
          },
          {
            action: 'cloudCannon/GET_CLOUD_CANNON_CONTENT',
            options: {
              cloudCannonResource: '/member-details.json'
            },
            config: {
              root: true
            }
          }
        ]
      },
      computedMemberAddresses() {
        if (!this.memberAddressesWithExtras) {
          return []
        }

        return this.memberAddressesWithExtras.filter(m => m.addressType === 'H')
      }
    },
    data() {
      return {
        fileBoundId: ''
      }
    },
    validations: {
      fileBoundId: {
        maxLength: maxLength(15),
        fileBoundIdValidation
      }
    }
  }
</script>
